import Vue from 'vue';
import Router from 'vue-router';
import store from './store/index';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/dashboard'
    },
    {
      path: '/login',
      name: 'LogIn',
      component: () => import(/* webpackChunkName: "login" */ './view/LogIn.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/signup',
      name: 'SignUp',
      component: () => import(/* webpackChunkName: "signup" */ './view/SignUp.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      meta: { requiresAuth: true },
      component: () => import(/* webpackChunkName: "dashboard" */ './view/Dashboard.vue')
    },
    {
      path: '/profile',
      name: 'Profile',
      meta: { requiresAuth: true },
      component: () => import(/* webpackChunkName: "profile" */ './view/Profile.vue')
    }
  ]
});

router.beforeEach((to, from, next) => {
  // this solution need for facebook login
  // see https://forum.vuejs.org/t/redirected-to-----after-redirect-from-facebook-login/9648
  if (to.path === '/_=_') {
    next('/');
    return;
  }
  const token = store.getters['app/token'];

  if (to.meta!.requiresAuth && !token) {
    next('/login');
  } else if (!to.meta!.requiresAuth && token) {
    next('/');
  } else {
    next();
  }
});

export default router;
